import { createStore } from 'vuex'
import { io } from 'socket.io-client'
import axios from 'axios'

// Устанавливаем базовый URL для всех запросов
let baseURL = 'https://tripbarg.com'
if(window.location.hostname === 'localhost') {
  baseURL = 'http://localhost:3000'
}

axios.defaults.baseURL = baseURL + '/api'

// Получаем токен из localStorage
const token = localStorage.getItem('auth_token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Создаем модуль для игры
const gameModule = {
  state: {
    score: 0,
    lives: 9,
    timeLeft: 30,
    coins: [],
    isPlaying: false,
    gameOver: true,
    isFirstGame: true,
    catScale: 0.5
  },
  mutations: {
    UPDATE_GAME_STATE(state, gameState) {
      console.log('Updating game state with:', gameState)
      Object.keys(gameState).forEach(key => {
        state[key] = gameState[key]
      })
    }
  }
}

export const store = createStore({
  state() {
    return {
      socket: null,
      error: null,
      socketConnected: false,
      game: {
        score: 0,
        lives: 9,
        timeLeft: 60,
        coins: [],
        isPlaying: false,
        gameOver: true,
        isFirstGame: true,
        catScale: 0.5
      },
      session: {
        token: token,
        userTag: localStorage.getItem('userTag') || null,
        isAuthenticated: !!token,
        hasPassword: false,
        hasWallet: false,
        walletAddress: null,
        bestScore: parseInt(localStorage.getItem('bestScore')) || 0,
        totalScore: parseInt(localStorage.getItem('totalScore')) || 0,
        wins: parseInt(localStorage.getItem('wins')) || 0,
        losses: parseInt(localStorage.getItem('losses')) || 0
      },
      highScores: [],
      autoConnect: true,
      userSOLBalance: 0,
      boardType: 'score',
      disclaimerAgreed: localStorage.getItem('disclaimerAgreed') === 'true',
      // bestScore: parseInt(localStorage.getItem('bestScore')) || 0,
      // totalScore: parseInt(localStorage.getItem('totalScore')) || 0,
      score: parseInt(localStorage.getItem('score')) || 0,
      weight: parseInt(localStorage.getItem('weight')) || 0,
      multiplayerStats: {
        wins: parseInt(localStorage.getItem('wins')) || 0,
        losses: parseInt(localStorage.getItem('losses')) || 0
      },
      stats: {
        strength: parseInt(localStorage.getItem('strength')) || 1,
        agility: parseInt(localStorage.getItem('agility')) || 1,
        stamina: parseInt(localStorage.getItem('stamina')) || 1,
        luck: parseInt(localStorage.getItem('luck')) || 1,
        intelligence: parseInt(localStorage.getItem('intelligence')) || 1
      },
      gameHistory: [],
      hideSeek: {
        stats: null,
        availableGames: [],
        gameHistory: [],
        currentGame: null,
        loading: false,
        error: null
      },
      soundEnabled: localStorage.getItem('soundEnabled') === 'true',
      currentAgent: JSON.parse(localStorage.getItem('selectedAgent')) || {
        name: 'BITCAT AI Agent',
        agentTag: 'main_agent',
        avatar: 26,
        description: 'Hello! I am BITCAT AI Agent. I am here to help you navigate the BITCAT Universe and answer your questions.'
      },
      agentInfo: JSON.parse(localStorage.getItem('agentInfo')) || {},
      chatOpen: false,
      agentsListOpen: false,
      chatAgents: []
    }
  },

  mutations: {
    SET_SESSION(state, sessionData) {
      state.session = { ...state.session, ...sessionData };
      if (sessionData.userTag) {
        localStorage.setItem('userTag', sessionData.userTag);
      }
      if (sessionData.token) {
        localStorage.setItem('auth_token', sessionData.token);
      }
    },

    UPDATE_GAME_STATE(state, gameState) {
      if (!state.game) {
        state.game = {
          score: 0,
          lives: 9,
          timeLeft: 60,
          coins: [],
          isPlaying: false,
          gameOver: true,
          isFirstGame: true,
          catScale: 0.5
        };
      }
      
      console.log('Updating game state:', {
        current: { ...state.game },
        new: gameState
      });
      
      // Обновляем каждое свойство отдельно
      Object.keys(gameState).forEach(key => {
        if (key === 'catScale') {
          console.log('Updating catScale:', {
            old: state.game.catScale,
            new: gameState.catScale
          });
        }
        state.game[key] = gameState[key];
      });
      
      console.log('Updated game state:', { ...state.game });
    },
    SET_SOCKET(state, socket) {
      console.log('Setting socket:', socket)
      state.socket = socket
    },
    SET_SOCKET_CONNECTED(state, connected) {
      state.socketConnected = connected;
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    setBalance(state, payload) {
      state.userSOLBalance = payload.balance
    },
    setBoardType(state, payload) {
      console.log(payload)
      state.boardType = payload.boardType
    },
    setDisclaimerAgreed(state, agreed) {
      state.disclaimerAgreed = agreed
      localStorage.setItem('disclaimerAgreed', agreed)
    },
    setStat(state, { stat, value }) {
      state.stats[stat] = value
      localStorage.setItem(stat, value)
    },
    // updateScores(state, score) {
    //   state.totalScore += score;
    //   localStorage.setItem('totalScore', state.totalScore.toString());
    //   // localStorage.setItem('bestScore', score.toString());
    // },
    SET_WALLET(state, hasWallet) {
      state.session.hasWallet = hasWallet;
    },
    SET_STATS(state, stats) {
      state.stats = { ...stats };
    },
    SET_SCORES(state, { bestScore, totalScore }) {
      state.session.bestScore = bestScore;
      state.session.totalScore = totalScore;
    },
    SET_TOTAL_SCORES(state, { totalScore }) {
      state.session.totalScore = totalScore;
    },
    SET_MULTIPLAYER_STATS(state, stats) {
      state.multiplayerStats = { ...stats };
    },
    setSession(state, { token, userTag, hasPassword, walletAddress, bestScore, totalScore, wins, losses }) {
      state.session = {
        token,
        userTag,
        hasPassword,
        isAuthenticated: true,
        walletAddress,
        hasWallet: walletAddress !== null,
        bestScore,
        totalScore,
        wins,
        losses
      }
      // Сохраняем токен в localStorage
      localStorage.setItem('auth_token', token)
      // Устанавливаем токен для всех последующих запросов
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      localStorage.setItem('userTag', userTag);
    },
    clearSession(state) {
      state.session = {
        token: null,
        userTag: null,
        isAuthenticated: false,
        hasPassword: false,
        walletAddress: null,
        hasWallet: false,
        bestScore: 0,
        totalScore: 0,
        wins: 0,
        losses: 0
      }
      // Удаляем токен из localStorage
      localStorage.removeItem('auth_token')
      // Удаляем токен из заголовков запросов
      delete axios.defaults.headers.common['Authorization']
      localStorage.removeItem('userTag');
      localStorage.removeItem('guest_playerId');
    },
    SET_GAME_HISTORY(state, history) {
      state.gameHistory = history;
    },
    CLEAR_GAME_HISTORY(state) {
      state.gameHistory = [];
    },
    UPDATE_GAME_HISTORY(state, gameHistory) {
      state.gameHistory = [
        gameHistory,
        ...state.gameHistory
      ].slice(0, 10); // Ограничиваем количество элементов до 10
    },
    SET_HIDE_SEEK_STATS(state, stats) {
      state.hideSeek.stats = stats
    },
    SET_HIDE_SEEK_GAMES(state, games) {
      state.hideSeek.availableGames = games
    },
    SET_HIDE_SEEK_HISTORY(state, history) {
      state.hideSeek.gameHistory = history
    },
    SET_CURRENT_HIDE_SEEK_GAME(state, game) {
      state.hideSeek.currentGame = game
    },
    SET_HIDE_SEEK_LOADING(state, loading) {
      state.hideSeek.loading = loading
    },
    SET_HIDE_SEEK_ERROR(state, error) {
      state.hideSeek.error = error
    },
    SET_SOUND_ENABLED(state, enabled) {
      state.soundEnabled = enabled;
      localStorage.setItem('soundEnabled', enabled);
    },
    SET_CURRENT_AGENT(state, agent) {
      state.currentAgent = agent;
      localStorage.setItem('selectedAgent', JSON.stringify(agent));
      
      // Store agent info in agentInfo object
      if (!state.agentInfo[agent.agentTag]) {
        state.agentInfo[agent.agentTag] = {
          name: agent.name,
          agentTag: agent.agentTag,
          avatar: agent.avatar
        };
        localStorage.setItem('agentInfo', JSON.stringify(state.agentInfo));
      }
    },
    SELECT_AGENT(state, agent) {
      state.currentAgent = agent
      localStorage.setItem('selectedAgent', JSON.stringify(agent))
      state.chatOpen = true
    },
    TOGGLE_CHAT(state, isOpen) {
      state.chatOpen = isOpen
    },
    TOGGLE_AGENTS_LIST(state, isOpen) {
      state.agentsListOpen = isOpen !== undefined ? isOpen : !state.agentsListOpen
    },
    DELETE_AGENT(state, agentTag) {
      if (agentTag === 'main_agent') return // Prevent deletion of main_agent
      
      // Remove from localStorage
      const chatHistory = JSON.parse(localStorage.getItem('chatHistory') || '{}')
      const agentInfo = JSON.parse(localStorage.getItem('agentInfo') || '{}')
      
      delete chatHistory[agentTag]
      delete agentInfo[agentTag]
      
      localStorage.setItem('chatHistory', JSON.stringify(chatHistory))
      localStorage.setItem('agentInfo', JSON.stringify(agentInfo))
      
      // Update store state
      state.agentInfo = agentInfo
      
      // Reload chat agents
      this.commit('LOAD_CHAT_AGENTS')
      
      // If deleted agent was current, switch to nearest agent
      if (state.currentAgent.agentTag === agentTag) {
        const index = state.chatAgents.findIndex(a => a.agentTag === agentTag)
        const nextAgent = state.chatAgents[Math.max(0, index - 1)]
        if (nextAgent) {
          this.commit('SET_CURRENT_AGENT', nextAgent)
        }
      }
    },
    UPDATE_AGENT_INFO(state, agent) {
      const agentInfo = JSON.parse(localStorage.getItem('agentInfo') || '{}')
      agentInfo[agent.agentTag] = {
        name: agent.name,
        agentTag: agent.agentTag,
        avatar: agent.avatar
      }
      localStorage.setItem('agentInfo', JSON.stringify(agentInfo))
      state.agentInfo = agentInfo
      
      // Update chatAgents
      this.commit('LOAD_CHAT_AGENTS')
    },
    LOAD_CHAT_AGENTS(state) {
      try {
        const agentInfo = JSON.parse(localStorage.getItem('agentInfo') || '{}')
        const agentTags = Object.keys(agentInfo)
        
        // Always include main_agent
        const mainAgent = {
          name: 'BITCAT AI Agent',
          agentTag: 'main_agent',
          avatar: 26
        }
        
        let agents = []
        
        // Add main_agent if not in agentInfo
        if (!agentInfo['main_agent']) {
          agentInfo['main_agent'] = mainAgent
          localStorage.setItem('agentInfo', JSON.stringify(agentInfo))
        }
        
        if (agentTags.length > 0) {
          agents = agentTags.map(tag => {
            if (agentInfo[tag]) {
              return {
                name: agentInfo[tag].name,
                agentTag: agentInfo[tag].agentTag,
                avatar: agentInfo[tag].avatar
              }
            }
            return null
          }).filter(agent => agent !== null)
        }
        
        // Ensure main_agent is in the list
        if (!agents.find(a => a.agentTag === 'main_agent')) {
          agents.push(mainAgent)
        }
        
        // Sort agents (main_agent first)
        state.chatAgents = agents.sort((a, b) => {
          if (a.agentTag === 'main_agent') return -1
          if (b.agentTag === 'main_agent') return 1
          return 0
        })
      } catch (error) {
        console.error('Failed to load agents:', error)
      }
    },
  },

  actions: {
    async checkUserTag({ commit }, userTag) {
      try {
        const response = await axios.post('/auth/check-tag', { userTag });
        return response.data;
      } catch (error) {
        throw error.response?.data?.error || 'Error checking user tag';
      }
    },

    async authenticateUser({ commit, dispatch }, { userTag, password = null, walletAddress = null }) {
      try {
        // Сначала проверяем существование пользователя
        const checkResponse = await axios.post('/auth/check-tag', { userTag });
        
        if (!checkResponse.data.exists) {
          // Если пользователь не существует, регистрируем его
          return await dispatch('register', { userTag, password, walletAddress });
        }
        
        // Теперь выполняем вход
        const response = await axios.post('/auth/login', {
          userTag,
          password,
          walletAddress
        });
        
        commit('setSession', {
          token: response.data.token,
          userTag: response.data.userTag,
          hasPassword: response.data.hasPassword,
          walletAddress: response.data.walletAddress,
          bestScore: response.data.bestScore,
          totalScore: response.data.totalScore,
          wins: response.data.wins,
          losses: response.data.losses
        });

        setTimeout(async () => {
          await dispatch('initializeAuth')
        }, 1000);

        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.error || 'Authentication failed');
      }
    },

    // async authenticateWithWallet({ commit, dispatch }, { userTag }) {
    //   try {
    //     // Проверяем существование пользователя
    //     const checkResponse = await axios.post('/auth/check-tag', { userTag });
        
    //     const walletAddress = localStorage.getItem('walletAddress');
    //     if (!walletAddress) {
    //       throw new Error('Wallet not connected');
    //     }

    //     if (!checkResponse.data.exists) {
    //       // Если пользователь не существует, регистрируем его с кошельком
    //       await dispatch('register', { 
    //         userTag, 
    //         walletAddress,
    //         password: null 
    //       });
    //     }
        
    //     // Теперь выполняем вход с кошельком
    //     const response = await axios.post('/auth/login', {
    //       userTag,
    //       walletAddress
    //     });
        
    //     commit('setSession', {
    //       token: response.data.token,
    //       userTag: response.data.userTag,
    //       hasPassword: response.data.hasPassword
    //     });

    //     axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;

    //     return response.data;
    //   } catch (error) {
    //     throw new Error(error.response?.data?.error || 'Wallet authentication failed');
    //   }
    // },

    async logout({ commit }) {
      try {
        await axios.post('/auth/logout');
      } catch (error) {
        console.error('Logout error:', error);
      } finally {
        commit('clearSession');
        commit('CLEAR_GAME_HISTORY');
      }
    },

    initSocket({ state, commit, dispatch }, { forceReconnect = false } = {}) {
      if (state.socket) {
        if(!forceReconnect) {
          return;
        }
        state.socket.disconnect();
      }

      const socket = io(baseURL, {
        auth: {
          token: localStorage.getItem('auth_token')
        }
      });

      socket.on('disconnect', () => {
        console.log('Socket disconnected');
        commit('SET_SOCKET_CONNECTED', false);
      });

      socket.on('connect', () => {
        console.log('Socket connected');
        commit('SET_SOCKET', socket);
        commit('SET_SOCKET_CONNECTED', true);
      });

      socket.on('gameState', (gameState) => {
        console.log('Received game state:', gameState);
        
        // Если игра закончилась и это был первый раз
        if (gameState.gameOver && state.game.isFirstGame) {
          gameState.isFirstGame = false;
        }
        
        commit('UPDATE_GAME_STATE', gameState);
      });

      socket.on('gameHistoryUpdated', (newEntry) => {
        commit('UPDATE_GAME_HISTORY', newEntry);
        
        console.log(' Game History Updated:', newEntry);
      });

      socket.on('error', (error) => {
        console.error('Socket error:', error);
        commit('SET_ERROR', error);
      });

      return socket;
    },

    startGame({ state, commit }, gameData) {
      if (state.socket) {
        const data = {
          playerId: gameData.playerId,
          gameConfig: {
            gameWidth: gameData.width,
            gameHeight: gameData.height
          }
        };
        console.log('Emitting startGame with data:', data);
        state.socket.emit('startGame', data);

        state.socket.on('gameStarted', (gameData) => {
          console.log('Game started');
          console.log(gameData.playerId);
          localStorage.setItem('guest_playerId', gameData.playerId);
          
        });

        state.socket.on('newUserScore', (scoreData) => {
          commit('SET_SCORES', scoreData);
        });
      } else {
        console.error('Socket not initialized');
        throw new Error('Socket not initialized');
      }
    },

    handleCoinClick({ state }, coordinates) {
      if (state.socket) {
        const clickData = {
          playerId: state.session.userTag || localStorage.getItem('guest_playerId'),
          clickData: coordinates
        };
        console.log('Emitting coinClick with data:', clickData);
        state.socket.emit('coinClick', clickData);
      } else {
        console.error('Socket not initialized');
      }
    },

    // endGame({ state }) {
    //   if (state.socket) {
    //     state.socket.emit('endGame');
    //   } else {
    //     console.error('Socket not initialized');
    //   }
    // },

    cleanup({ state, commit }) {
      if (state.socket) {
        state.socket.disconnect();
        commit('SET_SOCKET', null);
      }
    },

    cleanupHideSeek({ state, commit }) {
      if (state.socket) {
        state.socket.disconnect();
        // state.socket.off('game-created')
        // state.socket.off('game-started')
        // state.socket.off('guessing-phase')
        // state.socket.off('game-result')
        // state.socket.off('game-error')
        commit('SET_SOCKET', null);
      }
    },

    async changeWallet({ commit}, walletAddress) {
      try {
        const response = await axios.post('/auth/change-wallet', { walletAddress });
        console.log(response)
        commit('SET_WALLET', true)
        return response.data;
      } catch (error) {
        console.error('Change wallet error:', error);
        const errorMessage = error.response?.data?.error || 'Failed to change wallet';
        throw new Error(errorMessage);
      }
    },

    async register({ commit }, { userTag, password, walletAddress }) {
      try {
        const response = await axios.post('/auth/register', {
          userTag,
          password,
          walletAddress
        });

        // После успешной регистрации сразу авторизуем пользователя
        commit('setSession', {
          token: response.data.token,
          userTag: response.data.userTag,
          hasPassword: response.data.hasPassword,
          walletAddress: response.data.walletAddress
        });

        return response.data;
      } catch (error) {
        // console.log(error)
        // let message = 'An error occurred during registration'
        // if (error.response?.data?.error) {
        //   message = error.response.data.error
        // } else {
        //   message = error.message || 'An error occurred during registration'
        // }

        // console.log(message)

        throw error.response?.data?.error || 'An error occurred during registration';
      }
    },

    async login({ commit }, { userTag, password, walletAddress }) {
      try {
        const response = await axios.post('/auth/login', {
          userTag,
          password,
          walletAddress
        });

        const { token, ...sessionData } = response.data;
        
        commit('setSession', {
          token,
          userTag: sessionData.userTag,
          hasPassword: sessionData.hasPassword,
          walletAddress: sessionData.walletAddress
        });

        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        return response.data;
      } catch (error) {
        throw error.response?.data?.error || 'Login failed';
      }
    },

    async changePassword({ commit }, { currentPassword, newPassword }) {
      try {
        const response = await axios.post('/auth/change-password', {
          currentPassword,
          newPassword
        })
        
        if (response.data.success) {
          return true
        }
        throw new Error(response.data.error)
      } catch (error) {
        throw new Error(error.response?.data?.error || 'Failed to change password')
      }
    },

    async resetPassword({ commit }, { userTag }) {
      try {
        const response = await axios.post('/auth/reset-password', { userTag });
        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.error || 'Password reset failed');
      }
    },

    handleClick({ state }, clickData) {
      if (state.socket) {
        state.socket.emit('click', clickData);
      } else {
        console.error('Socket not initialized');
      }
    },
    initializeAuth({ commit }) {
      const token = localStorage.getItem('auth_token')
      if (token) {
        // Если токен есть в localStorage, восстанавливаем сессию
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        // Здесь можно сделать запрос на сервер для проверки валидности токена
        // и получения данных пользователя
        axios.get('/auth/me')
          .then(response => {
            commit('setSession', {
              wins: response.data.wins,
              losses: response.data.losses,
              token,
              userTag: response.data.userTag,
              hasPassword: response.data.hasPassword,
              hasWallet: response.data.hasWallet,
              walletAddress: response.data.walletAddress,
              bestScore: response.data.bestScore,
              totalScore: response.data.totalScore
            })
          })
          .catch(() => {
            // Если токен невалидный, очищаем сессию
            commit('clearSession')
          })
      }
    },
    async fetchGameHistory({ commit }) {
      try {
        const response = await axios.get(`${baseURL}/api/game-history`);
        commit('SET_GAME_HISTORY', response.data);
      } catch (error) {
        console.error('Error fetching game history:', error);
      }
    },
    async fetchUserGameHistory({ commit }, userTag) {
      try {
        const response = await axios.get(`/user/${userTag}/history`);
        commit('SET_GAME_HISTORY', response.data.gameHistory);
      } catch (error) {
        console.error('Error fetching user game history:', error);
      }
    },
    async fetchHideSeekStats({ commit }) {
      commit('SET_HIDE_SEEK_LOADING', true)
      try {
        const response = await axios.get('/hide-seek/stats')
        commit('SET_HIDE_SEEK_STATS', response.data)
      } catch (error) {
        commit('SET_HIDE_SEEK_ERROR', error.response?.data?.error || 'Failed to fetch stats')
      } finally {
        commit('SET_HIDE_SEEK_LOADING', false)
      }
    },
    
    async fetchAvailableHideSeekGames({ commit }) {
      commit('SET_HIDE_SEEK_LOADING', true)
      try {
        const response = await axios.get('/hide-seek/games')
        commit('SET_HIDE_SEEK_GAMES', response.data)
      } catch (error) {
        commit('SET_HIDE_SEEK_ERROR', error.response?.data?.error || 'Failed to fetch games')
      } finally {
        commit('SET_HIDE_SEEK_LOADING', false)
      }
    },

    async fetchHideSeekHistory({ commit }) {
      commit('SET_HIDE_SEEK_LOADING', true)
      try {
        const response = await axios.get('/hide-seek/history')
        commit('SET_HIDE_SEEK_HISTORY', response.data)
      } catch (error) {
        commit('SET_HIDE_SEEK_ERROR', error.response?.data?.error || 'Failed to fetch history')
      } finally {
        commit('SET_HIDE_SEEK_LOADING', false)
      }
    },
    async fetchHideSeekPlayerStats({ commit }, userTag) {
      try {
        const response = await axios.get(`/hide-seek/stats/${userTag}`);
        commit('SET_HIDE_SEEK_STATS', response.data);
        return response.data;
      } catch (error) {
        console.error('Error fetching Hide & Seek stats:', error);
        commit('SET_HIDE_SEEK_ERROR', error.message);
        return null;
      }
    }
  },

  getters: {
    currentScore: state => state.game.score,
    remainingLives: state => state.game.lives,
    timeLeft: state => state.game.timeLeft,
    activeCoins: state => state.game.coins,
    isPlaying: state => state.game.isPlaying,
    gameOver: state => state.game.gameOver,
    isFirstGame: state => state.game.isFirstGame,
    catScale: state => state.game.catScale,
    canPlay: state => !state.game.isPlaying && state.socket !== null,
    getBoardType: state => state.boardType,
    userTag: state => state.session.userTag,
    stats: state => state.stats,
    bestScore: state => state.session.bestScore,
    totalScore: state => state.session.totalScore,
    totalWins: state => state.session.wins,
    totalLosses: state => state.session.losses,
    hasPassword: state => state.session.hasPassword,
    isAuthenticated: state => state.session.isAuthenticated,
    hasWallet: state => state.session.hasWallet,
    walletAddress: state => state.session.walletAddress,
    multiplayerStats: state => state.multiplayerStats,
    gameHistory: state => state.gameHistory,
    hideSeekStats: state => state.hideSeek.stats,
    availableHideSeekGames: state => state.hideSeek.availableGames,
    hideSeekHistory: state => state.hideSeek.gameHistory,
    currentHideSeekGame: state => state.hideSeek.currentGame,
    isHideSeekLoading: state => state.hideSeek.loading,
    hideSeekError: state => state.hideSeek.error,
    socket: state => state.socket,
    isSocketConnected: state => state.socketConnected,
    soundEnabled: state => state.soundEnabled,
    currentAgent: state => state.currentAgent,
    agentInfo: state => state.agentInfo,
    chatOpen: state => state.chatOpen,
    agentsListOpen: state => state.agentsListOpen,
    chatAgents: state => state.chatAgents
  },
  
  modules: {
    game: gameModule
  }
})
